var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirCompressor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7826ff",
    d: "M24 12A12 12 0 1 1 12 0a12 12 0 0 1 12 12"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.822 -1.371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.489 8.78a4.667 4.667 0 1 0-4.666 4.667 4.671 4.671 0 0 0 4.666-4.667m-.7 0a3.964 3.964 0 1 1-3.964-3.964 3.969 3.969 0 0 1 3.962 3.964M17.458 6.9l-1.864 1.869c0 .028.008.055.008.083a.817.817 0 1 1-.817-.817.8.8 0 0 1 .209.031l1.816-1.817s.01-.005.014-.009a3.248 3.248 0 1 0 .634.665m-1.537 8.8v-1.249h-2.2v1.251H11.6v1h6.452v-1zm5.255 2H8.467v2.667h12.71zm-3.129 3.6H11.6v1h6.453z",
    fill: "#f5f5f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirCompressor);
export default __webpack_public_path__ + "static/media/air-compressor.0debf61289644893a679be2bd8011b8f.svg";
export { ForwardRef as ReactComponent };